/* eslint-disable no-unused-vars */
export enum MidiMessageIndex {
  STATUS,
  PITCH,
  VELOCITY,
}
/* eslint-enable no-unused-vars */

export const MIDI_MIN_OFF_CHANNEL_NUMBER = 128
export const MIDI_MAX_OFF_CHANNEL_NUMBER = 143
export const MIDI_MIN_CHANNEL_NUMBER = 144
export const MIDI_MAX_CHANNEL_NUMBER = 159

export const MIDI_PITCH_TO_KEY_OFFSET = -20

export function isAnOnMessage(messageData: Uint8Array): boolean {
  return messageData[MidiMessageIndex.STATUS] >= MIDI_MIN_CHANNEL_NUMBER
    && messageData[MidiMessageIndex.STATUS] <= MIDI_MAX_CHANNEL_NUMBER
    && messageData[MidiMessageIndex.VELOCITY] > 0
}
export function isAnOffMessage(messageData: Uint8Array): boolean {
  return (messageData[MidiMessageIndex.STATUS] >= MIDI_MIN_CHANNEL_NUMBER
    && messageData[MidiMessageIndex.STATUS] <= MIDI_MAX_CHANNEL_NUMBER
    && messageData[MidiMessageIndex.VELOCITY] === 0
  ) || (messageData[MidiMessageIndex.STATUS] >= MIDI_MIN_OFF_CHANNEL_NUMBER
    && messageData[MidiMessageIndex.STATUS] <= MIDI_MAX_OFF_CHANNEL_NUMBER)
}

